<template>
  <b-form-group
    label="Şehir"
    label-for="city"
  >
    <validation-provider
      #default="{ errors }"
      name="Şehir"
      rules="required"
    >
      <b-form-input
        id="city"
        v-model="itemData.city"
        placeholder="Şehir"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'CityText',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['products/dataItem']
    },
  },
}
</script>
